import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Typography } from 'seagull';
import { CloseCrossCircle } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { FeedbackPromptBar } from './FeedbackPromptBar';
import { UserActionStatus } from './UserActionStatus';
export const GetDismissedMessageTID = (parentTestId)=>getTestIds(parentTestId);
export const DismissedMessage = (param)=>{
    let { content, messageId, showFollowUpSuggestions = true, onSuggestionClick, onSubmitFeedback, onDismissFeedback } = param;
    const { DismissedMessageTID } = useMemo(()=>GetDismissedMessageTID(messageId), [
        messageId
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": DismissedMessageTID.Root(),
        children: [
            /*#__PURE__*/ _jsx(UserActionStatus, {
                Icon: CloseCrossCircle,
                iconSkin: "error",
                text: content.intro,
                testId: DismissedMessageTID.Intro()
            }),
            content.followUp != null && /*#__PURE__*/ _jsxs("div", {
                "data-testid": DismissedMessageTID.FollowUp(),
                children: [
                    content.followUp.text != null && /*#__PURE__*/ _jsx(Typography, {
                        testId: DismissedMessageTID.FollowUpText(),
                        children: content.followUp.text
                    }),
                    showFollowUpSuggestions && content.followUp.suggestions.length > 0 && /*#__PURE__*/ _jsx("div", {
                        "data-testid": DismissedMessageTID.FollowUpSuggestions(),
                        children: content.followUp.suggestions.map((suggestion, idx)=>/*#__PURE__*/ _jsx("button", {
                                type: "button",
                                "data-testid": DismissedMessageTID.FollowUpSuggestion(idx),
                                onClick: onSuggestionClick != null ? ()=>onSuggestionClick(suggestion) : undefined,
                                disabled: onSuggestionClick == null,
                                children: suggestion
                            }, idx))
                    })
                ]
            }),
            content.feedbackPrompt != null && onSubmitFeedback != null && onDismissFeedback != null && /*#__PURE__*/ _jsx(FeedbackPromptBar, {
                prompt: content.feedbackPrompt,
                onSubmit: onSubmitFeedback,
                onDismiss: onDismissFeedback,
                testId: messageId
            })
        ]
    });
};
